import { useRevealObserver } from '../components/motion';
import { Nav } from '../components/Nav';
import { Hero } from '../components/Hero';
import { Marquee } from '../components/Marquee';
import { Positioning } from '../components/Positioning';
import { Features } from '../components/Features';
import { HowItWorks } from '../components/HowItWorks';
import { Audiences } from '../components/Audiences';
import { InfraStrip } from '../components/InfraStrip';
import { PressStrip } from '../components/PressStrip';
import { Gallery } from '../components/Gallery';
import { Pricing } from '../components/Pricing';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import Footer from '../components/Footer';
import { JsonLd } from '../components/seo/JsonLd';
import { PageSeo } from '../components/seo/PageSeo';
import { buildHomePageSchema } from '../lib/schema';
import { HOME_META } from '../lib/seo';
import { Link } from 'react-router-dom';

export function HomePage() {
  useRevealObserver();

  return (
    <>
      <PageSeo meta={HOME_META} />
      <JsonLd data={buildHomePageSchema()} />
      <div id="grain" aria-hidden="true" />
      <Nav />
      <main className="home-page">
        <Hero />
        <Marquee />
        <PressStrip />
        <Positioning />
        <Features />
        <section className="section band-dark" aria-labelledby="home-comparisons-title">
          <div className="container py-20">
            <h2 id="home-comparisons-title" className="mkt-section-title">How Induce Compares</h2>
            <p className="body-lg max-w-3xl">See how Induce stacks up against Runway, Higgsfield, and LTX Studio on continuity, cost per minute, and commercial rights.</p>
            <nav aria-label="Compare Induce" className="flex flex-wrap gap-5 mt-8">
              <Link className="text-primary" to="/vs/runway">Induce vs Runway</Link>
              <Link className="text-primary" to="/vs/higgsfield">Induce vs Higgsfield</Link>
              <Link className="text-primary" to="/vs/ltx-studio">Induce vs LTX Studio</Link>
            </nav>
          </div>
        </section>
        <HowItWorks />
        <Audiences />
        <InfraStrip />
        <Gallery />
        <Pricing titleAs="h2" />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </>
  );
}
